import $ from "jquery";
import debug from 'bows/dist/bows.min.js';


let $narrative_slider = $('[data-slider="narrative"]');
let isEditor = true;

const log = debug("sliders:narattive");


function sliderInit() {

	$narrative_slider.each(function () {

		let $this = $(this);
		let role = $this.attr('role');
		let narrative = $this.closest('.narrative');
		let prev = narrative.find('button[data-direction="prev"]');
		let next = narrative.find('button[data-direction="next"]');
		let dots_div = narrative.find('.narrative__dots');
		let slider = '';


		if (role !== 'region') {
			slider = $this.slick({
				dots: true,
				appendDots: dots_div,
				speed: 500,
				arrows: true,
				nextArrow: next,
				prevArrow: prev,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
				variableWidth: true,
				responsive: [
					{
						breakpoint: 1350,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: false,
							variableWidth: true,
							infinite: false,
							dots: true,
							appendDots: dots_div,
							arrows: false
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: false,
							variableWidth: true,
							infinite: false,
							dots: true,
							appendDots: dots_div,
							arrows: false
						}
					},
				]
			});

			// prev.on('click', function () {
			// 	slider.slick('slickPrev');
			// });
			// next.on('click', function () {
			// 	slider.slick('slickNext');
			// });
		}

	});
}



$(function () {
	if ($narrative_slider.length) {
		sliderInit();
	}
})

